export function validateField(name) {
  let value = this.form[name];
  let validation = !!value;
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return !!value;
}

export function requiredFieldsFilled() {
  return Object.values(this.validations).every(
    (fieldValue) => fieldValue == true
  );
}
export function validateFieldFile(name) {
  let value = this.form[name];
  const validation = !!value && value.length > 0;
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}

export function validateCheckBox(name) {
  this.validations[name] = true;
  if (!this.formSubmited) return null;
  return true;
}


export function isValidCnpj(cnpj) {
  if (!cnpj) return false;

  const formatted = /^\d+$/.test(cnpj) ? cnpj.padStart(14, '0') : cnpj;

  const cleanedCnpj = formatted.toString().trim().replace(/[./-]/g, '').toUpperCase();

  const regexFormacaoComDV = /^[A-Z\d]{12}\d{2}$/;
  const regexValorZerado = /^0+$/;

  if (!regexFormacaoComDV.test(cleanedCnpj) || regexValorZerado.test(cleanedCnpj)) {
    return false;
  }

  // 3. Separa a base e os Dígitos Verificadores (DVs) informados
  const baseCnpj = cleanedCnpj.substring(0, 12);
  const dvInformado = cleanedCnpj.substring(12);

  // 4. Calcula os DVs e compara (Equivalente às linhas 14-16)
  const dvCalculado = calculaDV(baseCnpj);
  return dvCalculado === dvInformado;
}

// Função auxiliar para calcular os dois dígitos verificadores (Linhas 21-30 do Java)
function calculaDV(baseCnpj) {
  const dv1 = calculaDigito(baseCnpj);
  const dv2 = calculaDigito(baseCnpj + dv1);
  return `${dv1}${dv2}`;
}

// Algoritmo de cálculo do dígito usando o array de pesos (Linhas 32-39 do Java)
function calculaDigito(cnpj) {
  const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let soma = 0;

  // O código Java original percorre de trás para frente usando o deslocamento no array de pesos
  for (let i = cnpj.length - 1; i >= 0; i--) {
    // Converte o caractere para o seu valor numérico (tabela ASCII se for letra, ou o próprio dígito)
    // No Java: (int) cnpj.charAt(indice) - '0'
    const valorCaracter = cnpj.charCodeAt(i) - 48; // 48 é o valor ASCII do '0'

    // Alinha o peso dinamicamente com base no tamanho atual da string
    const pesoIndice = pesos.length - cnpj.length + i;
    soma += valorCaracter * pesos[pesoIndice];
  }

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function validateCnpj(name) {
  let value = this.form[name];
  let validation = isValidCnpj(value);
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}

export function validateCpf(name) {
  let value = this.form[name];
  let validation = cpf.isValid(value);
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}
function isValidHttpUrl(string) {
  try {
    const url = new URL(string);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (_) {
    return false;
  }
}


export function validateLink(name) {
  let value = this.form[name];

  let validation = isValidHttpUrl(value);
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}

export function validateFieldPhone(name) {
  let value = this.form[name];
  let validation = true;
  validation = !!value;
  validation = validation && (value.length == 11 || value.length == 10);

  this.validations[name] = validation;
  if (!this.formSubmited) return null;

  return validation;
}

export function validateFiedlCep(name) {
  let value = this.form[name];
  let validation = true;
  validation = !!value;
  validation = validation && value.length == 8;

  this.validations[name] = validation;
  if (!this.formSubmited) return null;

  return validation;
}

export function validateFieldPassword(name) {
  let value = this.form[name];
  const validation = !!value && value.length > 7;
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}

export function validateFieldSamePassword(name) {
  const validation =
    this.form.password == this.form.passwordConfirm;
  this.validations[name] = validation;
  if (!this.formSubmited) return null;

  return validation;
}

export function validateFieldEmail(name) {
  let value = this.form[name];
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let validation = re.test(value);
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}
export function validateFieldEndDate(name, startedName, mandatory = true) {
  let value = this.form[name];
  let validation = !!value;
  if (!mandatory && !value) {
    return true;
  }
  if (!value) {
    validation = false;
    this.endDateErrorMsg = "Data de término deve ser informada.";
  } else if (value) {
    const settedEndDate = new Date(value);
    const settedStartDate = new Date(this.form[startedName]);
    if (settedEndDate < settedStartDate) {
      validation = false;
      this.endDateErrorMsg =
        "A data de término deve ser posterior a data de início.";
    }
  }

  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}
export function validateFieldStartDate(name, onlyFutureDate) {
  let value = this.form[name];
  let validation = !!value;
  if (value) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let settedStartDate = value
    if (isValidDate(value)) {
      settedStartDate = formatStringHyphenToDate(value);
    }
    if (onlyFutureDate && today > settedStartDate) {
      validation = false;
      this.startDateErrorMsg =
        "Data de início não pode ser anterior a data atual.";
    }
  } else {
    validation = false;
    this.startDateErrorMsg = "Data de início deve ser informada.";
  }
  this.validations[name] = validation;
  if (!this.formSubmited) return null;
  return validation;
}
export function validateFieldStartDateOnChange(name, onlyFutureDate) {
  let value = this.form[name];
  let validation = !!value;
  if (value) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let settedStartDate = value
    if (isValidDate(value)) {
      settedStartDate = formatStringHyphenToDate(value);
    }
    if (onlyFutureDate && today > settedStartDate) {
      validation = false;
      this.startDateErrorMsg =
        "Data de início não pode ser anterior a data atual.";
    }
  } else {
    validation = false;
    this.startDateErrorMsg = "Data de início deve ser informada.";
  }
  this.validations[name] = validation;
  return validation;
}

import { cpf } from "cpf-cnpj-validator";
import {
  formatStringHyphenToDate,
  isValidDate
} from "../date/date-utils";